<template>
  <paginatron
    @change="updateItems"
    @next="advanced"
    @previous="decreased"
    :items="items"
    :items-per-page="pageItems"
    ref="paginatronRef"
  >
    <div
      slot-scope="{
        setPage,
        nextPage,
        prevPage,
        page,
        pages,
        hasNextPage,
        hasPrevPage,
        nextButtonEvents,
        prevButtonEvents,
        nextButtonAttrs,
        prevButtonAttrs,
      }"
    >
      <slot name="activeItems" :items="activeItems" :page="page"></slot>
      <div class="page-controls">
        <button
          class="arrow-buttons"
          v-on="prevButtonEvents"
          :disabled="!hasPrevPage"
        >
          <box-icon name="chevron-left"></box-icon>
        </button>
        <div class="pages-container">
          <button
            :class="['page-number', page === 0 ? 'active-page' : '']"
            @click="onPageSet(0, setPage, page, lastPage)"
          >
            1
          </button>
          <span v-if="page - 1 >= 4">...</span>
          <div v-for="pageNumber in pageNumbers" :key="pageNumber">
            <button
              :class="['page-number', pageNumber === page ? 'active-page' : '']"
              @click="onPageSet(pageNumber, setPage, page, lastPage)"
            >
              {{ pageNumber + 1 }}
            </button>
          </div>
          <span v-if="lastPage - page > 4">...</span>
          <button
            v-if="lastPage > 0"
            :class="['page-number', page === lastPage ? 'active-page' : '']"
            @click="onPageSet(lastPage, setPage, page, lastPage)"
          >
            {{ lastPage + 1 }}
          </button>
        </div>
        <button
          class="arrow-buttons"
          v-on="nextButtonEvents"
          :disabled="!hasNextPage"
        >
          <box-icon name="chevron-right"></box-icon>
        </button>
      </div>
    </div>
  </paginatron>
</template>

<script>
import Paginatron from "vue-paginatron";

export default {
  name: "Paginate",
  components: {
    Paginatron,
  },
  emits: ["page-change", "new-page"],
  props: {
    page: {
      type: Number,
    },
    items: {
      type: Array,
      default: [],
    },
    itemsPerPage: {
      type: Number,
      default: 12,
    },
  },
  model: {
    prop: "page",
    event: "new-page",
  },
  data: () => ({
    activeItems: [],
  }),
  methods: {
    updateItems(activeItems) {
      this.activeItems = activeItems;
    },
    decreased({ prev, current }) {
      this.$emit("page-change", { prev, current });
      this.$emit("new-page", current);
    },
    advanced({ activeItems, prev, current }) {
      this.$emit("page-change", { prev, current });
      this.$emit("new-page", current);
    },
    onPageSet(to, callback, from, total) {
      this.$emit("new-page", to);
      this.$emit("page-change", {
        prev: from,
        current: to,
        totalPages: total - 1,
      });

      callback(to);
    },
    updatePate(to) {
      this.$refs.paginatronRef.setPage(to);
    },
    numberToArray(number) {
      const numArr = [];
      for (let i = 0; i < number; i++) {
        numArr.push(i);
      }
      return numArr;
    },
  },
  computed: {
    pageItems() {
      return this.items.length >= this.itemsPerPage
        ? this.itemsPerPage
        : this.items.length;
    },
    lastPage() {
      return Math.floor(this.items.length / this.itemsPerPage);
    },
    currentPage() {
      return this.page;
    },
    pageNumbers() {
      const pages = this.numberToArray(this.lastPage);
      const length = 7;
      let start = 1;
      let end = this.lastPage;

      if (this.lastPage + 1 === length) {
        return pages.slice(1, 6);
      }

      if (this.page < 4) {
        start = 1;
        end = length;
        return pages.slice(start, end);
      }

      if (this.page >= this.lastPage - 3) {
        start = this.lastPage - length;
        end = this.lastPage;
        return pages.slice(start, end);
      }

      if (this.page > 3) {
        start = this.page - 3;
      }

      if (this.page < this.lastPage - 3) {
        end = this.page + 4;
      }

      return pages.slice(start, end);
    },
  },
  watch: {
    page(newPage, oldPage) {
      this.onPageSet(newPage, this.$refs.paginatronRef.setPage, this.page);
    },
  },
  mounted() {
    this.onPageSet(this.page, this.$refs.paginatronRef.setPage, this.page);
  },
};
</script>

<style>
.page-controls {
  margin-top: 10px;
  display: flex;
  justify-content: end;
  gap: 1rem;
  align-items: center;
}

.pages-container {
  display: flex;
  gap: 10px;
}

.page-controls button {
  background: none;
  height: 35px;
  width: 35px;
  cursor: pointer;
}

.page-controls .arrow-buttons {
  border: none;
}

.page-controls .arrow-buttons:disabled {
  opacity: 0.2;
}

.page-controls .arrow-buttons:enabled:hover {
  border-color: var(--rofix-lighter-gray);
  background-color: var(--rofix-lighter-gray);
}

.page-controls .page-number {
  border: 1px solid;
  border-color: var(--rofix-gray);
  color: var(--rofix-gray);
}

.page-controls .page-number.active-page,
.page-controls .page-number:hover {
  border-color: var(--rofix-primary);
  background-color: var(--rofix-primary);
  color: white;
}
</style>
